import React, { useEffect, useMemo } from "react";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../../hooks/useTableResponsive";

const AnnouncementPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const navigate = useNavigate();
  const {
    data: announcementsData = [],
    isLoading: announcementsDataIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "announcement",
    lang: languageType,
  });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(announcementsData)?.changed
    );
  }, [announcementsData]);

  useTableResponsive(announcementsData);

  if (announcementsDataIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Announcements", "घोषणाएं")}
        titleLink="/announcement-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Announcements", "घोषणाएं")}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="table-responsive">
              <table className="table table-striped custom-table">
                <thead className="thead-dark">
                  <tr>
                    <th>{getText("S.No.", "क्र. सं.")}</th>
                    <th>{getText("Announcement", "घोषणा")}</th>
                    <th>{getText("Detail", "विवरण")}</th>
                  </tr>
                </thead>
                <tbody>
                  {announcementsData.map((item, index) => (
                    <tr key={index}>
                      <td data-key={getText("S.No.", "क्र. सं.")}>
                        {index + 1}
                      </td>
                      <td data-key={getText("Announcement", "घोषणा")}>
                        {item.title}
                      </td>

                      <td data-key={getText("Detail", "विवरण")}>
                        <div>
                          <a
                            title={getText("More", "अधिक")}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/announcement-detail/${item.nid}`);
                            }}
                          >
                            {getText("More", "अधिक")}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <!--table grid end here--> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnouncementPage;
